<template>
    <div class="Form-inputGroup" :class="{ 'Form-inputGroup--error': validations ? validations.$error : false }">
        <label class="Form-label" v-bind:for="computedDefinition.id">{{computedDefinition.label}}{{computedDefinition.required ? '*' : ''}}</label>
        <div class="Input" :class="computedDefinition.class">
            <input
                v-if="computedDefinition.type !== 'textarea'"
                class="Input-field"
                ref="computedDefinition.id"
                v-bind:type="computedDefinition.type"
                v-bind:id="computedDefinition.id"
                v-bind:value="value"
                v-bind:disabled="computedDefinition.disabled"
                v-bind:required="computedDefinition.required"
                v-bind:placeholder="computedDefinition.placeholder"
                v-on:input="onInput($event.target.value)"
                v-on:blur="onBlur($event.target.value)"
            />
            <textarea
                v-if="computedDefinition.type === 'textarea'"
                class="Input-field Input-field--textarea"
                ref="computedDefinition.id"
                v-bind:id="computedDefinition.id"
                v-bind:disabled="computedDefinition.disabled"
                v-bind:required="computedDefinition.required"
                v-bind:placeholder="computedDefinition.placeholder"
                v-on:input="onInput()"
                v-on:blur="onBlur()"
                v-model="value"
            />
            <div class="Form-inputError" v-if="computedDefinition.required && value === '' && hasChanged">
                {{ computedDefinition.label }} is required
            </div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            validations: Object,
            definition: {
                type: Object,
                default: function() {
                    return {
                        id: 'field',
                        label: 'Field*',
                        class: '',
                        type: 'text'
                    }
                }
            },
            value: String,
        },
        computed: {
            computedDefinition() {
                return Object.assign({
                    id: 'field',
                    label: 'Field*',
                    class: '',
                    type: 'text'
                }, this.definition)
            }
        },
        methods: {
          onInput(newValue) {
              this.hasChanged = true;
              console.log('input', newValue);
              this.$emit('input', newValue);
          },
          onBlur(newValue) {
              this.hasChanged = true;
              this.$emit('blur'+this.computedDefinition.id, newValue);
          },
          validateInput() {
              this.isValid = this.validations.$invalid;
              this.$emit('invalid', true);
          }
        },
        data: function () {
            return {
                hasChanged: false,
                isValid: false
            }
        }
    }
</script>
